export default __webpack_public_path__ + "media/JSM_tablet.5e5e435360eabedfdd0af2fa4412b151.svg";